import React, {Component} from "react";
import PropTypes from "prop-types";


class CallButtonComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div
                style={{
                      background: "white",
                      borderRadius: "5px",
                      padding: "5px 20px",
                      boxShadow:
                        "0px 2px 11px rgb(0 0 0 / 30%), 0px 2px 6px rgb(0 0 0 / 15%",
                      width: "30%",
                      margin: "5px auto",
                    }}>
               <a href={"tel:" + this.props.phoneNumber} style={{color: "black"}}>
                    Click Here to Call
               </a>
            </div>
        );
    }
}

CallButtonComponent.propTypes = {
    steps: PropTypes.object,
};

CallButtonComponent.defaultProps = {
    steps: undefined,
};

export default CallButtonComponent;